import ScalarIconWarningCircle_vue_vue_type_script_setup_true_lang_default from "./ScalarIconWarningCircle.vue.script.js";
//#region src/components/ScalarIconWarningCircle.vue
var ScalarIconWarningCircle_default = ScalarIconWarningCircle_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconWarningCircle_default as default };

//# sourceMappingURL=ScalarIconWarningCircle.js.map